// SignUp.js

import {
    axios,
    useImperativeHandle, forwardRef, useRef, useContext, useState, useEffect,
    useSelector, useDispatch,
    useLocation, useNavigate, Link,
    AppTheme,
    mui, reducer, component, useShared,  
    replaceTabVerseListNewItem, setRead, getYearOfBirthList, localizedDateTime, verseRangeChineseName, sortResultList, canPushNewEntry, Highlight, resetSelectedAll, getBookChapterVerseChineseName, getChapterChineseName, getBookChapterChineseName, getTabLabel,
    DEV_ENABLED, VERSION, COUNTRY_LIST, MAX_LENGTH_SEARCH_STRING, MAX_LENGTH_NOTE_CONTENT, MAX_LENGTH_NOTE_TITLE, SPACE, API_BASE_URL, MAX_LENGTH_NON_SEARCH_STRING1, MAX_LENGTH_NON_SEARCH_STRING2,
    homeContext, searchContext, noteContext,
} from '../Utilities/sharedHeader';

const { styled, Card, Stack } = mui;

const CustomCard = styled(Card)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignSelf: 'center',
  width: '100%',
  maxWidth: '450px',
  padding: `${theme.spacing(4)} ${theme.spacing(1)}`, // Top-bottom: XXpx, Left-right: YYpx
  gap: theme.spacing(2),
  margin: 'auto',
  boxShadow:
    'hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px',
  [theme.breakpoints.up('sm')]: {
    width: '450px',
  },
  ...theme.applyStyles('dark', {
    boxShadow:
      'hsla(220, 30%, 5%, 0.5) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.08) 0px 15px 35px -5px',
  }),
}));

const SignUpContainer = styled(Stack)(({ theme }) => ({
  height: 'calc((1 - var(--template-frame-height, 0)) * 120dvh)',
  minHeight: '100%',
  padding: theme.spacing(2),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(4),
  },
  '&::before': {
    content: '""',
    display: 'block',
    position: 'absolute',
    zIndex: -1,
    inset: 0,
    backgroundImage:
      'radial-gradient(ellipse at 50% 50%, hsl(210, 100%, 97%), hsl(0, 0%, 100%))',
    backgroundRepeat: 'no-repeat',
    ...theme.applyStyles('dark', {
      backgroundImage:
        'radial-gradient(at 50% 50%, hsla(210, 100%, 16%, 0.5), hsl(220, 30%, 5%))',
    }),
  },
}));

export default function SignUp(props) {

  const profile4PersonalRef = useRef(null);

  const { Slider, Snackbar, styled, grey, Grid, Chip, Divider, Tab, Tabs, Box, Accordion, AccordionSummary, AccordionDetails, ListItemIcon, List, ListItem, ListItemText, TextField, IconButton, InputBase, Paper, Alert, Select, FormControl, FormControlLabel, FormLabel, FormGroup, MenuItem, Container, Typography, ButtonGroup, Button, Stack, Fab, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Radio, RadioGroup, AppBar, Toolbar, Table, TableContainer, TableBody, TableRow, TableCell, CardMedia, CardContent, CssBaseline, FormHelperText, Switch, Card, CheckIcon, ClearIcon, DeleteIcon, CloseIcon, ExpandMoreIcon, VisibilityOutlinedIcon, KeyboardArrowUpIcon, KeyboardDoubleArrowUpIcon, HistoryIcon, StickyNote2Icon, NoteAddIcon, SearchIcon, DescriptionIcon, EditDocumentIcon, ImportContactsIcon, WestIcon, EastIcon, HomeIcon, PersonIcon, LogoutIcon, PlagiarismIcon, DeviceThermostatIcon, FileCopyIcon, LocalOfferIcon, InfoIcon } = mui;
  const { setButtonTextDialog4, setButtonText, setDialogTitle, setBookReadLogToBeCleared, setCallerConfirmationDialog, setCaller4NoteBookmarkList, setNoteSearchString, setConfirmedNoteSearchString, setNoteSearchStringClearButton, setShowRemainingNoteSearch, setSearchCriteriaListItem2, setSearchResultVerseList2, setPageNumberNoteSearch, setVerseListItem2, setNoteSearchStringPlaceHolder, reset4NoteSearch, setTabVerseListNew, reset4SignIn, setTitleToBeDeleted, reset4ConfirmationDialog, reset4GoToTopButtonVisible, reset4NoteBookmarkList, reset4Dialog4, reset4NoteBookmarkVerseList, reset4ChipArray, reset4verseLabelArrows4Result, reset4Switch1, reset4Dialog2, reset4Search, reset4Verse, reset4Chapter, reset4Book, reset4Home, setGoToTopButtonVisible, setVerseListItem, setNonSearchString1PlaceHolder, setNonSearchString2PlaceHolder, setSearchStringPlaceHolder, setSearchString, setShowLeftArrowVerseSearch, setShowRightArrowVerseSearch, setShowfabContentVerseSearch, setShowLeftArrowNote, setShowRightArrowNote, setShowfabContentNote, setShowLeftArrowNoteSearch, setShowRightArrowNoteSearch, setShowfabContentNoteSearch, setSearchCriteriaListItem, setPageNumberVerseSearch, setOpenConfirmationDialog, setOpen3, setConfirmedTabNumber, setOpen2, setPageNumberNote, setDetails, setLengthIndicator4Details, setLengthIndicator4Title, setLoading, setHistoryList, setHistoryListItemSelected, setHistoryBookChapter, setNoteBookmarkList, setNoteBookmarkListBookChapterVerse, setConfirmedSearchString, setNonSearchString1, setNonSearchString2, setSearchStringClearButton, setNonSearchStringClearButton, setSearchScopeList, setSearchScopeListItemSelected, setChipData, setShowRemaining, setSearchResultVerseList, setSearchHttpPostData, setBookChapterList, setBookChapterListItemSelected, setOpen1, setBookListItemSelected, setSearchCriteria, setUserListItem, setVerseReadLogList4Book, setSearchTabNumber, setBookChapter, setBookList, setTitle, setTitleClearButton, setBook4Accordion1, setChapter4Accordion1, setVerse4Accordion1, setBookChapter2, setBookChapterList2, setVerseList4Accordion1, setNoteBookmarkVerseList, setNoteBookmarkListItemToBeDeleted, setNoteBookmarkListItemToBeChanged, setTab4AddChange, setViewArea, setCredential, setCircularProgressText, setEmailExisted, setUsernameExisted, setLastNameOverMaxLength, setFirstNameOverMaxLength, reset4Profile } = reducer;
  const { SignUpEmailSent, Profile4System, Profile4Personal, History, AddChangeNote, FullFormatVerse, Book, Stack1, NoteVerseList, Chapter, Dialog1, Dialog2, Dialog3, Dialog4, Tab1, Navbar, VerseSearch, Verse, NoteBookmarkList, NoteBookmarkListItem, VerseLabelArrows4Result, ConfirmationDialog, Accordion1, ChipArray, SearchResult, ForgotPassword, ClipLoader1, VerseLabelArrows, Switch1, Selection, Profile, UserListItem } = component;  
  const { getTempCredential, sendEmail4SignUp, postUserListItem, bookRead, deleteVerseReadLogList, getNoteBookmarkList3, deleteLogListItem, getToken, postLogListItem, postPutSearchCriteriaListItem, deleteVerseReadLogListItem, postPutVerseReadLogListItem, postHistoryListItem, getHasNoteVersesAll, getSearchResultVerseList, getSearchCriteriaListItem, postNoteBookmarkListItem, putNoteBookmarkListItem2, putNoteBookmarkListItem1, getNoteBookmarkList, getVerseReadLogList4Book, getSearchScopeList, getVerseList4Accordion1, getUserListItem, getVerseList, getBookList, getHistoryList, putUserListItem } = useShared();

  // const dispatch = useDispatch(); // dispatch(
  // const credential = useSelector((state) => state.signIn.credential);
  //const userListItem = useSelector((state) => state.home.userListItem);
  //const userListItemToBeAdded = useSelector((state) => state.profile.userListItemToBeAdded);
  
  const [userListItemToBeAdded, setUserListItemToBeAdded] = useState({
    FirstName: '',
    LastName: '',
    YearOfBirth: 0,
    Gender: 'M',
    TimeZoneID: '00',
    Email: '',
    UserName: '',
    Password: '',
    PasswordRetype: ''

  });
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [loading4Home, setLoading4Home] = useState(false);

  const navigate = useNavigate();

  // const CustomCard = styled(Card)(({ theme }) => ({
  //   display: 'flex',
  //   flexDirection: 'column',
  //   alignSelf: 'center',
  //   width: '100%',
  //   maxWidth: '450px',
  //   padding: `${theme.spacing(4)} ${theme.spacing(1)}`, // Top-bottom: XXpx, Left-right: YYpx
  //   gap: theme.spacing(2),
  //   margin: 'auto',
  //   boxShadow:
  //     'hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px',
  //   [theme.breakpoints.up('sm')]: {
  //     width: '450px',
  //   },
  //   ...theme.applyStyles('dark', {
  //     boxShadow:
  //       'hsla(220, 30%, 5%, 0.5) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.08) 0px 15px 35px -5px',
  //   }),
  // }));

  // const SignUpContainer = styled(Stack)(({ theme }) => ({
  //   height: 'calc((1 - var(--template-frame-height, 0)) * 120dvh)',
  //   minHeight: '100%',
  //   padding: theme.spacing(2),
  //   [theme.breakpoints.up('sm')]: {
  //     padding: theme.spacing(4),
  //   },
  //   '&::before': {
  //     content: '""',
  //     display: 'block',
  //     position: 'absolute',
  //     zIndex: -1,
  //     inset: 0,
  //     backgroundImage:
  //       'radial-gradient(ellipse at 50% 50%, hsl(210, 100%, 97%), hsl(0, 0%, 100%))',
  //     backgroundRepeat: 'no-repeat',
  //     ...theme.applyStyles('dark', {
  //       backgroundImage:
  //         'radial-gradient(at 50% 50%, hsla(210, 100%, 16%, 0.5), hsl(220, 30%, 5%))',
  //     }),
  //   },
  // }));

  const handleOnClickSave = async (event) => {

    setLoading4Home(true);

    event.preventDefault();

    const personal = await profile4PersonalRef.current.validateInputs();

    if (personal) {

      const updatedPersonal = profile4PersonalAdded(userListItemToBeAdded, personal);
      setUserListItemToBeAdded(updatedPersonal);

      const tempCredential = await getTempCredential();

      if (tempCredential) {
        const item = {
          Credential: tempCredential,
          ...updatedPersonal, 
          VerseSearchResultPerPage: 25,
          NotePerPage: 12,
          HistoryListItemTotal: 10,
          VerseFontSize: 24,
          Status: 'Pending',
          DevEnabled: DEV_ENABLED,
        };      
        await postUserListItem(item, 'SignUp');
        sendEmail4SignUp(item, 'SignUp');
        navigate('/sign-up-email-sent', { state: { username: item.UserName, email: item.Email } }); 
        setLoading4Home(false);      
      }
      else {
        setLoading4Home(false); 
      }

    }   
    else {
      setLoading4Home(false); 
    } 

  };

  const profile4PersonalAdded = (a, b) => {
    return {...a, 
        LastName: b.LastName,
        FirstName: b.FirstName,
        YearOfBirth: b.YearOfBirth,
        Gender: b.Gender,
        TimeZoneID: b.TimeZoneID,
        Email: b.Email,
        UserName: b.UserName,
        Password: b.Password.length === 0 ? a.Password : b.Password,
    }
  }

  // const postUserListItem = async () => {
  //     try {
  //       const httpPostData = {
  //         FirstName: userListItemToBeAdded.FirstName,
  //         LastName: userListItemToBeAdded.LastName,
  //         YearOfBirth: userListItemToBeAdded.YearOfBirth,
  //         Gender: userListItemToBeAdded.Gender,
  //         CountryID: userListItemToBeAdded.Country,
  //         Email: userListItemToBeAdded.Email,
  //         UserName: userListItemToBeAdded.Username,
  //         Password: userListItemToBeAdded.Password
  //       };
  //       const url = API_BASE_URL + 'api/UserListItem/Post/';
  //       await axios.post(url, httpPostData);
  //       navigate('/emailsender', { state: httpPostData });
  //     } catch (error) {
  //       console.log(error);
  //     }
  // }

  return (
    
    <AppTheme {...props}>

      <CssBaseline enableColorScheme />

      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start', height: '100vh', overflowY: 'auto' }}>

      <SignUpContainer direction="column">

        <CustomCard variant="outlined">
          
          <Typography
            component="h1"
            variant="h4"
            sx={{ width: '100%' }}
          >
            「聖經筆記網」建立帳戶
          </Typography>

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>

          <Grid container spacing={2} padding={2}>

            <Grid size={12}>
              <Profile4Personal ref={profile4PersonalRef} mode={'Post'} userListItem={userListItemToBeAdded}/>
            </Grid>

            <Grid size={12} sx={{ paddingTop: '0px', paddingBottom: '0px', alignItems: 'center' }}>
              <IconButton
                sx={{
                  borderRadius: 1,
                  bgcolor: 'primary.main',
                  '&:hover': { bgcolor: 'primary.main' },
                  width: '100%',
                }}
                onClick={handleOnClickSave}
              >
                <CheckIcon sx={{ color: 'white' }} />
              </IconButton>   
            </Grid>             

          </Grid>

          </Box>

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Typography sx={{ textAlign: 'center' }}>
              已經有帳戶了嗎？{' '}
              <Link
                to='/signin'
                variant='body2'
                sx={{ alignSelf: 'center' }}
              >
                登入帳戶
              </Link>
            </Typography>
          </Box>

        </CustomCard>

      </SignUpContainer>

      {loading4Home && <ClipLoader1 />}

      </div>

    </AppTheme>

  );
}